export const environment = {
  production: true,
  envName: '%%envName%%',
  apiUrl: '%%apiUrl%%',
  ipv4ApiUrl: '%%ipv4ApiUrl%%',
  wsUrl: '%%wsUrl%%',
  cloudDnsWsUrl: '%%cloudDnsWsUrl%%',
  googleSiteKey: '%%googleSiteKey%%',
  cdnAuthRedirectUrl: '%%cdnAuthRedirectUrl%%',
  cloudMailAuthRedirectUrl: '%%cloudMailAuthRedirectUrl%%',
  gpuCloudAuthRedirectUrl: '%%gpuCloudAuthRedirectUrl%%',
  release: '@@version@@',
  enableCDNS: '%%enableCDNS%%',
  enableCDN: '%%enableCDN%%',
  enableCloudMail: '%%enableCloudMail%%',
  forceDevWsProtocol: 'wss',
  mojeIdConnectRedirectUrl: '%%mojeIdConnectRedirectUrl%%',
  mojeIdLoginRedirectUrl: '%%mojeIdLoginRedirectUrl%%',
  googleConnectRedirectUrl: '%%googleConnectRedirectUrl%%',
  googleLoginRedirectUrl: '%%googleLoginRedirectUrl%%',
  contractorIdCz: '%%contractorIdCz%%',
  stripePublishableKeyCz: '%%stripePublishableKeyCz%%',
  contractorIdDe: '%%contractorIdDe%%',
  stripePublishableKeyDe: '%%stripePublishableKeyDe%%',
  appleIdConnectRedirectUrl: '%%appleConnectRedirectUrl%%',
  appleIdLoginRedirectUrl: '%%appleLoginRedirectUrl%%',
  logoDevPublishableKey: '%%logoDevPublishableKey%%'
};
